<div class="footer-container mb-3 col-11">
  <span class="mb-3">
    Copyright © {{current_year}} by NSICC. All rights reserved.</span>
  <p class="d-none">{{'Application version: ' + version_info.version + ', git-hash: ' + version_info.hash}}</p>
</div>